import componentStyles from './noImage.module.css';

const NoImage = () => {
    return (
        <div className={componentStyles.noImagePlaceholder}>No Image</div>
    )
}

export default NoImage;